import { DialogContent, Box, useTheme } from "@mui/material";
import { MessagesByDay } from "../MyMessagesTypes";
import { useTaskerMessageContext } from "../../TaskerMessageContext";
import { DayDialogTitle } from "./title";
import { DayDialogContainer } from "./container";
import { TaskerMessageCardList } from "./TaskerMessageCardList";
import { StatsGrid } from "../StatsGrid";

interface DayDialogProps {
  handleCloseDayDialog: () => void;
  selectedDay: string;
  messagesByDay: MessagesByDay;
}

export const DayDialog = ({
  handleCloseDayDialog,
  selectedDay,
  messagesByDay,
}: DayDialogProps) => {
  const theme = useTheme();
  const { userTaskerConfigs } = useTaskerMessageContext();

  return (
    <DayDialogContainer
      selectedDay={selectedDay}
      handleCloseDayDialog={handleCloseDayDialog}
      theme={theme}
    >
      <DayDialogTitle
        selectedDay={selectedDay}
        handleCloseDayDialog={handleCloseDayDialog}
      />

      <DialogContent sx={{ p: 0 }}>
        {selectedDay && (
          <Box>
            <StatsGrid
              approved={messagesByDay[selectedDay].approved}
              rejected={messagesByDay[selectedDay].rejected}
              pending={messagesByDay[selectedDay].pending}
              total={messagesByDay[selectedDay].messages.length}
            />
            <TaskerMessageCardList
              messagesByDay={messagesByDay}
              selectedDay={selectedDay}
              userTaskerConfigs={userTaskerConfigs}
            />
          </Box>
        )}
      </DialogContent>
    </DayDialogContainer>
  );
};
